import * as React from "react";  

function SvgMinus(props) {   
    return (     
     <svg width="1em" height="1em" viewBox="0 0 8 2" {...props}>       
        <rect         
            width={8}         
            height={2}         
            fill="currentColor"         
            data-name="Ret\xE2ngulo 226"         
            rx={1}       
        />     
     </svg>   
    ); 
}  
export default SvgMinus;